<template>
  <a :href="href" class="g-cell" @click="callback">
    <span class="g-cell-mask" v-if="isLink"></span>
    <div class="g-cell-wrapper">
        <div class="g-cell-title">
            <slot name="icon"></slot>
            <slot name="title">
                <span class="g-cell-text" v-text="title" v-if="title"></span>
                <slot name="label">
                    <span v-text="label" class="g-cell-label"></span>
                </slot>
            </slot>
        </div>
        <div class="g-cell-value" :class="{ 'is-link' : isLink }">
            <slot name="value">
                <span v-text="value"></span>
            </slot>
        </div>
        <i v-if="isLink" class="g-cell-allow-right"></i>
    </div>
  </a>
</template>

<script>
export default {
  name: 'VCell',
  props: {
    to: [String, Object],
    icon: String,
    title: String,
    label: String,
    isLink: Boolean,
    value: {}
  },
  computed: {
    href () {
      if (this.to && !this.added && this.$router) {
        const resolved = this.$router.match(this.to);
        if (!resolved.matched.length) return this.to;
        this.$nextTick(() => {
          this.added = true;
          this.$el.addEventListener('click', this.handleClick);
        });
        return resolved.fullPath || resolved.path;
      }
      return this.to;
    }
  },
  methods: {
    handleClick ($event) {
      $event.preventDefault();
      this.$router.push(this.href);
    },
    callback () {
      this.$emit('click');
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/var.scss";
.g-cell {
  background-color: $color-white;
  box-sizing: border-box;
  color: inherit;
  min-height: 48px;
  display: block;
  overflow: hidden;
  position: relative;
  text-decoration: none;
  .g-cell-wrapper {
    align-items: center;
    box-sizing: border-box;
    display: flex;
    font-size: 1.4rem;
    line-height: 1;
    min-height: inherit;
    overflow: hidden;
    padding: 0 10px;
    width: 100%;
    border-bottom: solid 1px $color-border;
    padding: 25px 10px;
    .g-cell-text {
      vertical-align: middle;
    }
    .g-cell-label {
      color: #888;
      display: block;
      font-size: 12px;
      margin-top: 6px;
    }
    .g-cell-title {
      flex: 1;
    }
    .g-cell-value {
      color: $color-grey;
      display: flex;
      align-items: center;
      &.is-link {
        margin-right: 24px;
      }
    }
    img {
      vertical-align: middle;
      margin: 0 10px;
    }
  }
  .g-cell-mask {
    &::after {
      background-color: #000;
      content: " ";
      opacity: 0;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }
    &:active::after {
      opacity: 0.1;
    }
  }
  .g-cell-allow-right::after {
    border: solid 2px $color-border;
    border-bottom-width: 0;
    border-left-width: 0;
    content: " ";
    position: absolute;
    width: 5px;
    height: 5px;
    top: 50%;
    right: 20px;
    transform: translateY(-50%) rotate(45deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/base/cell.vue